"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AugustSDK = void 0;
const pools_1 = require("@augustdigital/pools");
const utils_1 = require("@augustdigital/utils");
class AugustSDK extends utils_1.AugustBase {
    constructor(baseConfig) {
        super(baseConfig);
        this.authorized = true;
        if (Object.keys(this.providers).length === 0)
            throw new Error('Must pass at least 1 provider.');
        this.pools = new pools_1.default(baseConfig);
    }
    switchNetwork(chainId) {
        this.activeNetwork = {
            chainId,
            rpcUrl: this.providers[chainId],
        };
    }
}
exports.AugustSDK = AugustSDK;
//# sourceMappingURL=main.js.map